<template>
  <v-container fluid v-show="mostrar">
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="mx-auto" elevation="0">
          <v-toolbar flat color="primarytwo" dark dense>
            <v-toolbar-title>Verifica codigo QR</v-toolbar-title>
          </v-toolbar>

          <v-card-text v-show="verDatos">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Documento</td>
                    <td>{{ defaultItem.documentoIdentidad }}</td>
                  </tr>
                  <tr>
                    <td>Nro Documento</td>
                    <td>{{ defaultItem.documentoId }}</td>
                  </tr>
                  <tr>
                    <td>Apellido Paterno</td>
                    <td>{{ defaultItem.apellidoPaterno }}</td>
                  </tr>
                  <tr>
                    <td>Apellido Materno</td>
                    <td>{{ defaultItem.apellidoMaterno }}</td>
                  </tr>
                  <tr>
                    <td>Nombre</td>
                    <td>{{ defaultItem.nombres }}</td>
                  </tr>
                  <tr>
                    <td>Periodo</td>
                    <td>{{ defaultItem.periodopago }}</td>
                  </tr>
                  <tr>
                    <td>Cargo</td>
                    <td>{{ defaultItem.cargo }}</td>
                  </tr>
                  <tr>
                    <td>Dependencia</td>
                    <td>{{ defaultItem.dependencia }}</td>
                  </tr>
                  <tr>
                    <td>Total Ingresos</td>
                    <td>{{ defaultItem.totalIngresos }}</td>
                  </tr>
                  <tr>
                    <td>Total Descuentos</td>
                    <td>{{ defaultItem.totalDescuentos }}</td>
                  </tr>
                  <tr>
                    <td>Neto Apagar</td>
                    <td>{{ defaultItem.totalNetoApagar }}</td>
                  </tr>

                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions v-show="verDatos">
            <v-btn color="red darken-1" class="white--text my-2" :loading="btnDescargar.loading"
              :disabled="btnDescargar.loading" small @click.stop="btnBoletaPagoClick()">
              Descargar Boleta Pago
              <v-icon dark small>
                mdi-cloud-download
              </v-icon></v-btn>
          </v-card-actions>
          <v-card-text v-show="verMensajeError">
            <v-alert color="red" type="warning"> Codigo QR no ha podido ser verificado, consultar en la oficina de
              recursos humanos</v-alert>
          </v-card-text>
          <v-card-text v-show="procesarDatos">
            <v-container>
              <v-row align-content="center">
                <v-col>
                  <v-progress-circular indeterminate ></v-progress-circular> Procesando....
                </v-col>
              </v-row>
            </v-container>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-snackbar v-model="mensaje.snack" :timeout="mensaje.tiempo" :color="mensaje.snackColor" top right>
          {{ mensaje.snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="mensaje.snack = false">
              <v-icon dark>mdi-close-box</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
import axios from "axios";
export default {
  name: "verificaqr",
  components: {},
  data: () => ({
    options: {},
    mostrar: true,
    mostrarDatos: false,
    procesarDatos: true,
    mensaje: {
      snack: false,
      snackColor: "",
      snackText: "",
      tiempo: 2000,
    },
    form: {
      deshabilita: false,
      valid: true,
    },
    defaultItem: {
      idPlanillaPersona: 0,
      documentoIdentidad: "",
      documentoId: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      nombres: "",
      periodopago: "",
      dependencia: "",
      cargo: "",
      totalIngresos: 0,
      totalDescuentos: 0,
      totalNetoApagar: 0,

    },
    btnDescargar: {
      loading: false,
    },
  }),
  watch: {},
  created: function () {

  },
  computed: {
    verDatos: function () {
      return this.mostrarDatos;
    },
    verMensajeError: function () {
      if (this.mostrarDatos || this.procesarDatos) {

        return false;
      } else {

        return true;
      }
    }
  },
  mounted: function () {
    this.btnVerificaQRClick(this.$route.params.qr);
  },
  methods: {
    apiListar(dataqr) {
      return new Promise((resolve, reject) => {
        let url =
          "api/VerificaCodigoQR/VerificaQR/" + dataqr;
        axios
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    apiBoletaPago(data) {
      return new Promise((resolve, reject) => {
        let url = "api/VerificaCodigoQR/DescargarBoleta/" + data.idPlanillaPersona;
        let configuracion = {
          responseType: "blob",
        };
        axios
          .get(url, configuracion)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async btnVerificaQRClick(qr) {
      try {
        const respuesta = await this.apiListar(qr);
        if (respuesta) {
          this.defaultItem.idPlanillaPersona = respuesta.result.idPlanillaPersona;
          this.defaultItem.documentoIdentidad = respuesta.result.documentoIdentidad;
          this.defaultItem.documentoId = respuesta.result.documentoId;
          this.defaultItem.apellidoPaterno = respuesta.result.apellidoPaterno;
          this.defaultItem.apellidoMaterno = respuesta.result.apellidoMaterno;
          this.defaultItem.nombres = respuesta.result.nombres;
          this.defaultItem.periodopago = respuesta.result.periodopago;
          this.defaultItem.dependencia = respuesta.result.dependencia;
          this.defaultItem.cargo = respuesta.result.cargo;
          this.defaultItem.totalIngresos = respuesta.result.totalIngresos;
          this.defaultItem.totalDescuentos = respuesta.result.totalDescuentos;
          this.defaultItem.totalNetoApagar = respuesta.result.totalNetoApagar;
          this.mostrarDatos = true;
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "colorErrorLocal";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "colorErrorServer";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        //this.griddata.loading = false;
        this.procesarDatos = false;
      }
    },
    async btnBoletaPagoClick() {
      try {
        this.btnDescargar.loading = true;
        let data = {
          idPlanillaPersona: this.defaultItem.idPlanillaPersona,
        };
        const respuesta = await this.apiBoletaPago(data);
        if (respuesta) {
          let nombrearchivo =
            "Boleta Pago " +
            this.defaultItem.documentoId +
            "-" +
            this.defaultItem.periodopago +
            ".pdf";
          const url = window.URL.createObjectURL(new Blob([respuesta]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombrearchivo);
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "colorErrorLocal";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "colorErrorServer";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        this.btnDescargar.loading = false;
      }
    },
  },
};
</script>
